import React, { useState, useEffect, useContext } from 'react';
import useQueries from '../../../database/useQueries';
import FormTemplate from '../../template/form/FormTemplate';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import LoadingOverlay from '../pagesMains/LoadingOverlay';
import { DataContext, TemplateContext } from '../pagesMains/GravesManagers/Graves';
import { GlobalContext } from '../../../App';
import { createFetchDataServer } from '../../../database/fetchData';

const NAME_ENTITY = 'בית עלמין';

function CemeteryUpdate() {
  // קבלת ערכים מהסטור
  const columns = useSelector((state) => state.columnsFormCemeteries.data);

  const { setTitle } = useContext(GlobalContext);
  const { setTotalWidthContainer } = useContext(TemplateContext);

  const context = useContext(DataContext);
  const fetchDataServer = createFetchDataServer(context);

  // טעינת היוזים לפונקציות עזר
  const { addOrUpdateDataCemetery } = useQueries();

  // ערכי הראוטר
  const location = useLocation();
  const navigate = useNavigate();
  const { value } = location.state || {};
  const [myCemetery, setMyCemetery] = useState(context?.contextCemeteries?.find((cemetery) => cemetery?.unicId === value?.unicId) || value);
  useEffect(() => {
    setMyCemetery(context?.contextCemeteries?.find((cemetery) => cemetery?.unicId === value?.unicId) || value);
  }, [context?.contextCemeteries]);

  useEffect(() => {
    setTotalWidthContainer(1200);
    setTitle(`עדכון בית עלמין`);
  }, [location.pathname]);

  // איזור המשתנים והסטייטים
  const [fieldsWithDynamicDisabled, setFieldsWithDynamicDisabled] = useState([]); // השדות
  const [formValues, setFormValues] = useState({}); // ערכי השדות
  const [errors, setErrors] = useState({}); // שגיאת השדות
  // עוקב אחר שליחת נתונים לשרת דרך פונקציית סבמיט
  const [loadingData, setLoadingData] = useState(false);

  const myColumns = () => {
    return columns.map((field) => {
      let lock = false;
      return {
        ...field,
        disabled: lock ? lock : field.disabled && myCemetery !== undefined,
        required: field.required || false,
        show: field?.show || false
      };
    });
  };

  // טעינת הנתונים לאחר קבלת הערכים מהדאטה בייס הלוקלי
  const handleAllDataLoaded = () => {
    setFieldsWithDynamicDisabled(myColumns());
    if (myCemetery?.unicId) {
      const initialFormValues = myColumns()
        .filter((field) => field?.name)
        .reduce(
          (acc, field) => {
            let fieldValue = myCemetery[field.name] || '';
            return {
              ...acc,
              [field.name]: fieldValue
            };
          },
          {
            id: myCemetery?.id,
            unicId: myCemetery?.unicId
          }
        );

      setFormValues(initialFormValues);
    }
  };

  // פעולות המתבצעות רק לאחר קבלת דאטה בייס ווליו מהראוטר
  useEffect(() => {
    handleAllDataLoaded();
  }, []);

  const handleChange = (event) => {
    setFormValues({ ...formValues, [event.target.name]: event.target.value });
  };

  const validateForm = () => {
    let tempErrors = {};
    let formIsValid = true;

    let cemeteries = context?.contextCemeteries?.filter((cemetery) => cemetery?.unicId !== formValues);

    columns.forEach((field) => {
      if (field?.required && !formValues[field.name]) {
        tempErrors[field.name] = 'שדה חובה';
        formIsValid = false;
      }
      if (field.notRepeat && formValues[field.name]) {
        if (cemeteries?.filter(item => item?.unicId !== value?.unicId)?.some((item) => item[field.name] === formValues[field.name])) {
          tempErrors[field.name] = `הערך ${formValues[field.name]} כבר קיים`;
          formIsValid = false;
        }
      }
    });

    setErrors(tempErrors);
    return formIsValid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      setLoadingData(true);

      let res = await addOrUpdateDataCemetery(formValues);
      if (res === 200) {
        let updateCemetery = context?.contextCemeteries?.find((cemetery) => cemetery?.unicId === formValues?.unicId);
        updateCemetery = { ...updateCemetery, ...formValues };

        let update =  { cemeteryNameHe: updateCemetery.cemeteryNameHe, cemeteryNameEn: updateCemetery.cemeteryNameEn }

        context?.setContextCemeteries((prev) => prev.map((item) => (item.unicId === updateCemetery.unicId ? updateCemetery : item)));
        context?.setContextBlocks((prev) => prev.map((item) => (item.cemeteryId === updateCemetery.unicId ? { ...item, ...update } : item)));
        context?.setContextPlots((prev) => prev.map((item) => (item.cemeteryId === updateCemetery.unicId ? { ...item, ...update } : item)));
        context?.setContextAreaGraves((prev) => prev.map((item) => (item.cemeteryId === updateCemetery.unicId ? { ...item, ...update } : item)));
        setLoadingData(false);
        navigate(-1);
      }
    }
  };

  if (loadingData) return <LoadingOverlay />;

  return <FormTemplate title={`עריכת ${NAME_ENTITY}`} btn={`עדכן`} fields={fieldsWithDynamicDisabled} columns={columns} formValues={formValues} handleChange={handleChange} handleSubmit={handleSubmit} errors={errors} />;
}

export default CemeteryUpdate;
